function parseHex(hex: string): [number, number, number] {
  const normalized = hex.replace("#", "");
  if (!/^[0-9a-f]{6}$/i.test(normalized)) return [91, 55, 45];
  return [
    Number.parseInt(normalized.slice(0, 2), 16),
    Number.parseInt(normalized.slice(2, 4), 16),
    Number.parseInt(normalized.slice(4, 6), 16),
  ];
}

export function mixColors(first: string, second: string, weight: number): string {
  const a = parseHex(first);
  const b = parseHex(second);
  const ratio = Math.min(Math.max(weight, 0), 1);
  const mixed = a.map((channel, index) => Math.round(channel * (1 - ratio) + b[index] * ratio));
  return `#${mixed.map((channel) => channel.toString(16).padStart(2, "0")).join("")}`;
}
